import {
  getServiceListApi,
  getServiceDetailApi,
  getServiceCountApi,
  createServiceApi,
  deleteServiceApi,
} from "api/service";

/// ✅ 문의 내역 가져오기
export const getInquiryData = async (amount, userId, lastCreateDate) => {
  try {
    const list = await getServiceListApi(userId);
    // 서버는 오프셋 기반이 아니므로 클라이언트측에서 slice 로 단순 분할.
    if (!Array.isArray(list) || list.length === 0) return [];
    const limit = amount || list.length;
    const startAt = lastCreateDate
      ? list.findIndex((r) => r.createDate === lastCreateDate) + 1
      : 0;
    return list.slice(startAt, startAt + limit);
  } catch (error) {
    console.error("failed getInquiryData:", error);
    return [];
  }
};

export const getInquiryDataPrev = async (amount, userId, lastCreateDate) => {
  try {
    const list = await getServiceListApi(userId);
    if (!Array.isArray(list) || list.length === 0) return [];
    const limit = amount || list.length;
    const endAt = lastCreateDate
      ? list.findIndex((r) => r.createDate === lastCreateDate)
      : list.length;
    return list.slice(Math.max(0, endAt - limit), endAt);
  } catch (error) {
    console.error("failed getInquiryDataPrev:", error);
    return [];
  }
};

export const getInquiryById = async (docId) => {
  try {
    return await getServiceDetailApi(docId);
  } catch (error) {
    console.error("failed getInquiryById:", error);
    return;
  }
};

export const deleteInquiry = async (docId) => {
  try {
    const result = await deleteServiceApi(docId);
    return !!(result && result.success);
  } catch (error) {
    console.error("failed deleteInquiry:", error);
    return false;
  }
};

export const createInquiry = async (userData, title, body, selectCategory) => {
  try {
    const result = await createServiceApi({
      body,
      comment: "",
      id: userData.id,
      name: userData.name,
      status: "0",
      title,
      type: selectCategory,
      userType: userData.userType,
    });
    return !!(result && result.success);
  } catch (error) {
    console.error("failed createInquiry:", error);
    return false;
  }
};

export const getInquiryDataCount = async (userId) => {
  try {
    return await getServiceCountApi(userId);
  } catch (error) {
    console.error("failed getInquiryDataCount:", error);
    return 0;
  }
};
